import React, {Component} from 'react';
import './PageHeader.css';
import {SearchBox, CompactSearch} from '../search';
import {connect} from 'react-redux';
import {Link, matchPath} from 'react-router-dom';
import {Avatar, ScrolledHeader} from '../widgets';
import {ProfileSuggestionsBackdrop} from '../profile/';
import uiActions from './ui.actions';
import {UserMenu, MobileUserMenu, notificationsActions} from '../user/';
import {createSelector} from 'reselect';
import PageFooter from './PageFooter';
import {Route, Switch} from 'react-router-dom';
import MobileNav from './MobileNav';
import {STREAM_WHITELISTED_USERS} from '../betaFeatureWhiteList';

const HEADER_HEIGHT_VH = 0.45; // 0.5 - .05 buffer
/**
 * Sits at the top of the page of landing page and search. Compresses as needed.
 *
 * Generally shows branding, recommendations/previews, the search box and user avatar for access to user menu.
 */
class PageHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			proportion: 0,
			searchExpanded: props.screenSize !== 'mobile'
		};

		this.getUnreadNotifications = createSelector(
			props => props.notificationItems,
			notificationItems => notificationItems && notificationItems.filter(item => !item.viewed)
		);

		this.scrollHandler = () => {
			// find the scroll distance on mobile

			// Find the proportion of the header height has been scrolled rounded to 10%.
			let proportion = window.scrollY / window.innerHeight / HEADER_HEIGHT_VH;
			proportion = Math.min(Math.max(Math.round(proportion * 10) / 10, 0), 1); // Limit and round to 0.1
			if (proportion !== this.state.proportion) {
				this.setState({proportion});
			}
		};

		this.optimisedScrollHandler = () => window.requestAnimationFrame(this.scrollHandler);

		this.expandSearch = () => {
			this.setState({searchExpanded: true});
			this.search.focus(); // Nasty hacky to focus input.
		};
		this.collapseSearch = () => this.setState({searchExpanded: false});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.screenSize !== this.props.screenSize) {
			// Hide search if resized to mobile
			this.setState({searchExpanded: nextProps.screenSize !== 'mobile'});
		}
	}

	componentDidMount() {
		window.addEventListener('scroll', this.optimisedScrollHandler);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.optimisedScrollHandler);
	}

	render() {
		const {path, children, login, signup, current, toggleUserMenu, title, screenSize} = this.props;

		const notificationItems = this.getUnreadNotifications(this.props);

		const avatarImage = current && current.provider && current.provider.profile.avatarImage;

		const isHome = matchPath(path, {path: '/'}).isExact || matchPath(path, {path: '/stream'});
		const isSearch = !!matchPath(path, {path: '/search/'});
		const firstMatch =
			!isHome &&
			this.props.enlargenFor.reduce(
				(accum, item) =>
					accum || (matchPath(path, {path: item && item.path ? item.path : item}) && item),
				null
			);

		// The header is expanded by default unless explicitly disabled
		const isPageWantingExpanded = firstMatch && firstMatch.showHeading !== false;

		const compact = !(isHome || isPageWantingExpanded);

		const chatNotifCount =
			notificationItems && notificationItems.filter(item => item.type === 'chat').length;

		return (
			<header
				className={`PageHeader ${compact ? 'PageHeader-compact' : ''} ${
					this.state.proportion >= 1 ? 'scrolled' : ''
				}`}>
				{screenSize !== 'mobile' ? (
					<React.Fragment>
						<ProfileSuggestionsBackdrop compact={compact} hidden={isPageWantingExpanded} />
						<nav
							className={`PageHeader-topNav ${isHome ? '' : 'search-suitable-page'} ${
								isSearch ? 'search-page' : ''
							} ${this.state.searchExpanded ? 'search-expanded' : ''}`}
							style={{backgroundColor: `rgba(0,79,113,${this.state.proportion})`}}>
							{screenSize === 'tablet' && !isHome ? (
								<a onClick={this.goBack} className="backArrow">
									<span className="icon icon-arrow_back" />
								</a>
							) : null}
							<Link to="/">
								<h1>
									<img alt="B2Me" src="/img/b2me-header.svg" />
								</h1>
							</Link>
							<span className="PageHeader-spacer" />
							{/*{!current && <Link to="/sign-up" className="PageHeader-signup">Sign up</Link>}*/}

							<CompactSearch
								refGetter={el => (this.search = el)}
								className={`PageHeader-search ${isHome ? '' : 'suitable-page'} ${
									this.state.searchExpanded ? 'expanded' : ''
								}`}
								onBlur={this.props.screenSize === 'mobile' ? this.collapseSearch : null}
							/>
							<button
								className={`PageHeader-searchExpander ${isHome ? '' : 'suitable-page'} ${
									this.state.searchExpanded ? 'expanded' : ''
								}`}
								onClick={this.expandSearch}>
								<span className="icon icon-search" />
							</button>

							{!current && (
								<button className="PageHeader-signup" onClick={signup}>
									<em>Free</em> sign up
								</button>
							)}
							{!current && (
								<button className="PageHeader-login" onClick={login}>
									Log in
								</button>
							)}

							{current &&
								current.provider &&
								(current.user.admin || STREAM_WHITELISTED_USERS.includes(current.user.uuid)) && (
									<Link to="/stream/" className="PageHeader-stream">
										<span className="icon icon-view_day" />
									</Link>
								)}
							{current && current.provider && current.provider.profile && (
								<Link to={`/chats/`} className="PageHeader-chats">
									{chatNotifCount ? (
										<span className="PageHeader-badge">{chatNotifCount}</span>
									) : (
										undefined
									)}
									<span className="icon icon-message" />
								</Link>
							)}
							{current && current.provider && current.provider.profile && (
								<Link
									to={`/collections/${current.provider.profile.uniqueName}`}
									className="PageHeader-profile">
									<span className="icon icon-favorite" />
								</Link>
							)}
							{current && (
								<button onClick={toggleUserMenu}>
									<Avatar extraClass="PageHeader-avatar" backgroundImage={avatarImage} size={32} />
									{notificationItems && notificationItems.length ? (
										<span className="PageHeader-badge">{notificationItems.length}</span>
									) : (
										undefined
									)}
								</button>
							)}
						</nav>
					</React.Fragment>
				) : (
					// MOBILE NAV
					<MobileNav
						login={login}
						signup={signup}
						notificationItems={notificationItems}
						toggleUserMenu={toggleUserMenu}
						avatarImage={avatarImage}
						chatNotifCount={chatNotifCount}
						current={current}
						isHome={isHome}
					/>
				)}

				{current && screenSize !== 'mobile' ? <UserMenu /> : <MobileUserMenu />}
				{isHome && !isPageWantingExpanded && screenSize !== 'mobile' && (
					<SearchBox compact={compact} />
				)}
				{firstMatch && firstMatch.title && firstMatch.showHeading ? (
					<h1>{firstMatch.title}</h1>
				) : null}
				{screenSize !== 'mobile' && screenSize !== 'tablet' && firstMatch && firstMatch.title ? (
					<ScrolledHeader>{firstMatch.title}</ScrolledHeader>
				) : null}
				{firstMatch && firstMatch.backdrop ? (
					<div
						className="PageHeader-backdrop"
						style={{backgroundImage: `url("${firstMatch.backdrop}")`}}
					/>
				) : null}
				{children}
			</header>
		);
	}
}

const ConnectedPageHeader = connect(
	state => ({
		path: state.router.location.pathname,
		current: state.session && state.session.status === 'authenticated' && state.session.current,
		screenSize: state.ui.screenSize,
		notificationItems: state.notifications && state.notifications.items
	}),
	dispatch => ({
		login: () => {
			// We need to request here as notification requests are done on user actions only.
			// This is the most appropriate user action I could think of, since notifications could be for anything on the site.
			notificationsActions.requestNotificationPermission();
			dispatch(uiActions.uiModal('login'));
		},
		signup: () => {
			// We need to request here as notification requests are done on user actions only.
			// This is the most appropriate user action I could think of, since notifications could be for anything on the site.
			notificationsActions.requestNotificationPermission();
			dispatch(uiActions.uiModal('signup'));
		},
		toggleUserMenu: () => dispatch(uiActions.showUserMenu())
	})
)(PageHeader);

export default ConnectedPageHeader;



// WEBPACK FOOTER //
// ./src/chrome/PageHeader.js